<div class="footer">
  <p class="watermark">Made by Stellar</p>
</div>
